<template>
    <input type="text" v-model="cpf_cnpj" />
</template>
<script>

export default {
    props: ['value'],
    data() {
        return {
            proxy: '',
        }
    },
    methods: {
        formatter(str) {
            let value = (str+'').replace(/\D+/igm,'').substr(0,14);
            if (11 >= value.length) {
                value = value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/, '$1.$2.$3-$4');                
            } else {
                value = value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})$/, '$1.$2.$3/$4-$5');                
            }
            return value.replace(/\D+$/, '');            
        }
    },
    computed: {
        cpf_cnpj: {
            get() {
                let cpf_cnpj = this.proxy;
                return this.formatter(cpf_cnpj);
            },
            set(value) {
                this.proxy = ' ';
                this.proxy = '';
                this.proxy = this.formatter(value);
                this.$emit('input', this.proxy);
            }
        }
    },
    watch: {
        value: {            
            handler(value) {
                this.cpf_cnpj = value;
            },
            immediate: true
        }
    }
}
</script>